// src/encounter/lib/to-gender-id.ts
// Map the patient sex ('M'|'F'|'X') → the MasterManagement gender value-set GUID that
// QuestionBank's encounter-template `gender` axis matches on (QB stores a Guid?, NOT
// 'M'/'F'). GUIDs are from ScripsCommon.dbo.Genders, provided by Samer for PROD-1162
// (contract PROD-1155, 2026-06-13). The "Both" value-set (dfd65f6b…) is an author-side
// scope (a template that applies to both sexes), never a single patient's value, so it
// is intentionally absent from this patient→GUID map.
export const GENDER_VALUE_SET = {
  male: 'dcd65f6b-b4ad-e711-811d-0025903a03a1',
  female: 'ddd65f6b-b4ad-e711-811d-0025903a03a1',
  unknown: 'ded65f6b-b4ad-e711-811d-0025903a03a1',
} as const;

/**
 * Patient sex → gender value-set GUID for the template `gender` axis.
 * - 'M' → Male, 'F' → Female, anything else present ('X'/other) → Unknown.
 * - An ABSENT sex returns `undefined` → the axis stays unconstrained on the BFF
 *   (matches every gender scope), per the optional-axis contract (PROD-1155).
 */
export function toGenderId(sex?: string): string | undefined {
  if (!sex) return undefined;
  const s = sex.trim().toUpperCase();
  if (s === 'M') return GENDER_VALUE_SET.male;
  if (s === 'F') return GENDER_VALUE_SET.female;
  return GENDER_VALUE_SET.unknown;
}
